import { render } from "./editStudentInfo.vue?vue&type=template&id=71de2686"
import script from "./editStudentInfo.vue?vue&type=script&lang=js"
export * from "./editStudentInfo.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\UG_College_administration\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__